import React, { PureComponent, Fragment } from 'react';
import { Link } from "react-router-dom";
import {
  Card, CardBody, Row, Col, Nav, NavLink, NavItem, TabContent, TabPane, Container,
} from 'reactstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import buyersListActions from '../../../../../redux/actions/buyersListActions';
import { Badge, Table } from 'reactstrap';
import { Tooltip } from '@material-ui/core';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Panel from './../../../../../shared/components/Panel';
import EmptyBuyersList from '../../../../BuyersLists/components/EmptyBuyersList';
import LinearLoading from '../../../../../shared/components/LinearLoading';

import { _axiosCall } from '../../../../../shared/helpers/apicalls';
import {
	buildingFL,
	_capitalizeText,
	_getBuildingURL,
	_shouldShow,
	_formatNumber,
	_formatPrice,
	UnitCurrentStatus,
	_nameToUrl,
	ProfileAvatar
} from "../../../../../shared/helpers/utils";

import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

const buildingUrl = process.env.API_ROOT + '/query/';
const styles = theme => ({
	  root: {
		display: 'flex',
		flexDirection: 'column',
		//marginLeft:"-8px",
		marginBottom:"15px",
		alignItems: 'left',
		'& > *': {
		   
		},
	  },
	  button:{
		'&.selected' :{
			background:"#D1D6E0"
		},
		fontSize:11,
		width:90
	  }
	});
	
const ShowList = ({data, title, header, color}) => {
	
	
	return (
		<Card className={"pb-0"}>
		<CardBody style={{padding:15}}>
		 <div className="card__title">
		  <h5 className="bold-text">{title}</h5>
		 </div>
		<Table responsive className="table-striped">
			{header &&
			<tr>
				<th colSpan={2} className="no-padding">{header}</th>
			</tr>
			}
		  <tbody>
		  {data && Array.isArray(data) && data.length>0 ? 
			  <Fragment>
			  {data.slice(0, 3).map((item, i) => {
			  const display = item.val.display_name;
			  return (
			 
					  <tr key={i} style={{border:0,cursor:"pointer"}}>
						  <td>
							  <Badge style={{ width:70,background:color }}>
								  <div className="bold-text">{_formatNumber(item.count)}</div> 
							  </Badge>
						</td>      				       	
						<td>
							<div className="bold-text">{display}</div>
							{item.val.company &&
								<div className="small-text light-text">{item.val.company}</div>
							}
						</td>   
						{/*<td>
							<ProfileAvatar 
							 contact={item.val}                          
							 companyCard={true}
							/>
						</td>*/}   	
					  </tr>
				  
				)
			  
		  	})}
			  </Fragment>
			:
			<tr>
				<td colSpan={2} className="text-center">
					<div className="bold-text">No {title} Found</div>
				</td>
			</tr>
			}
		   
		  </tbody>
		</Table>
		
		</CardBody>
		</Card>

	)
}
class BuildingEnergy extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
		  fetchInProgress: false,
		  data: null,
		  period: "1"
		};
	}
	
	componentDidUpdate(prevProps, prevState, snapshot) {
		if(this.state.period !== prevState.period){
			this._getBuildingEnergy();
		}
		
	}

	componentDidMount() {
		this._getBuildingEnergy();
		
		  
	}
	_setBuyersList = (res) => {	  
		 const list = res.docs ? res.docs.map(building => {
			 return Object.assign({}, building, this.props.savedBuildings.filter(item => item.key === building.key)[0]);
		 }) : []
		 this.setState({ 
			buyersList: list,
			incompleteMyBuyersLists: list.filter(item => !item.completed),
			completedMyBuyersLists: list.filter(item => item.completed),		
		});
	}

			
			
	_getBuildingEnergy = async () => {
			const { buildingRes } = this.props;
			const addressQ = buildingRes.alternate_addresses.join('" OR "');		
			this.setState({fetchInProgress:true})
			const q = `alternate_addresses:("${addressQ}") AND (zip:${buildingRes.zip} OR borough:"${buildingRes.borough}")`;
			const fq = [
				
			]
			let axiosData = {
				url: buildingUrl + "we3-energy-score?cache=3600",
				method: "post",
				query: {
					q: q,
					sort: "year_ending desc",
					wt: "json",
					fq: fq,
					rows: 5,
				}
			}
			
			let formattedData = await _axiosCall(axiosData)
				.then(res => {
					// console.log('Chart Data', res);
					if(res && res.stats){
						this.setState({data: res.stats, fetchInProgress:false});
					}else{
						this.setState({data: false,  fetchInProgress:false});
					}
						
				})
				.catch(error => {
					console.log("error: " + error);
				});
		
	}
		

  
  handleBuildingClick = (event, building, tab) => {
	 event.stopPropagation();
	 const buildingURL = _getBuildingURL(building, 'building_slugs') + (tab ? `/${tab}` : '');
	 this.props.history.push(buildingURL);
  };
  
  setPeriod = (period) => {
	  this.setState({period:period})
  }
  
  render(){
	const { savedUnits, totalCount, period, data, fetchInProgress } = this.state;
	const { classes, type } = this.props;
		
	return (
		<Card>
		   <CardBody>
			   <Row>
					   <Col md={12} className={"mb-0"}>
						   <div className="card__title">
						  <h5 className="bold-text">{'Top Lenders & Agents In This Building'}</h5>
						  {/*<h5 className="subhead">Top Listings, Contracts and Closing for The {type == "resale" ? "Resale Condo Market" : 'New Development Market'}</h5>*/}
						</div>
						   <div className={classes.root}>
								 
						  <ButtonGroup size="small" aria-label="small button group" >
						  	  {/*<Tooltip title="Top consumer lenders and brokerges" aria-label="Top consumer lenders and brokerges">
									   <Button onClick={()=> this.setPeriod("99")} className={period === "99" ? classNames(classes.button, "selected") : classNames(classes.button)}>All-Time</Button>
								  </Tooltip>*/}								        
							  <Tooltip title="Top consumer lenders and brokerges over the last 1 year" aria-label="Top consumer lenders and brokerges over the last 1 year">
								<Button onClick={()=> this.setPeriod("1")} className={period === "1" ? classNames(classes.button, "selected") : classNames(classes.button)}>1-Year</Button>
							</Tooltip>
							<Tooltip title="Top consumer lenders and brokerges over the last 2 year" aria-label="Top consumer lenders and brokerges over the last 2 year">
								<Button onClick={()=> this.setPeriod("2")} className={period === "2" ? classNames(classes.button, "selected") : classNames(classes.button)}>2-Year</Button>
							</Tooltip>
							<Tooltip title="Top consumer lenders and brokerges over the last 5 year" aria-label="Top consumer lenders and brokerges over the last 5 year">
								<Button onClick={()=> this.setPeriod("5")} className={period === "5" ? classNames(classes.button, "selected") : classNames(classes.button)}>5-Year</Button>
							</Tooltip>
							{/*<Tooltip title="Top consumer lenders and brokerges over the last 10 year" aria-label="Top consumer lenders and brokerges over the last 10 year">
									<Button onClick={()=> this.setPeriod("10")} className={period === "10" ? classNames(classes.button, "selected") : classNames(classes.button)}>10-Year</Button>
							   </Tooltip>*/}
						  
						  </ButtonGroup>
					  </div>
					   </Col>
			   </Row>
			   
			   {(!data || fetchInProgress) ?
				   <div>
				   <LinearLoading />
				   <div style={{height:300}}>
					   
				   </div>
				   </div>
				   
				   :
				 
				   <Row>
					   <Col md={6} className={"mb-0"}>
						   <ShowList data={data && data.company_lenders && data.company_lenders.lender ? data.company_lenders.lender : false} header={"# of Loans"} title={"Consumer Lenders"} color={"#B070CC"} />
					   </Col>
					   <Col md={6} className={"mb-0"}>
							  <ShowList data={data && data.people_agents && data.people_agents['real-estate-agent'] ? data.people_agents['real-estate-agent'] : false} header={"# of Listings"} title={"Listing Agents"} color={"#B070CC"} />
					   </Col>	
					   {/*<Col md={6} className={"mb-0"}>
						   <ShowList data={data && data.company_brokers && data.company_brokers.brokerage ? data.company_brokers.brokerage : false} header={"# of Listings"} title={"Brokerages"} color={"#B070CC"} />
					   </Col>*/}
					  				   	  
						
				   </Row>
			   }
			 
			 </CardBody>
		</Card>
	
	)
	
   }
};

BuildingEnergy.propTypes = {
  t: PropTypes.func.isRequired,
};
function mapStateToProps(state) {
  const buyersLists = state.buyersLists.priorityFilter
	? state.buyersLists.buyersLists.filter(item => item.priority === state.buyersLists.priorityFilter)
	: state.buyersLists.buyersLists;
  return { buyersLists, theme: state.theme, rtl: state.rtl, 
			  savedUnits: Array.isArray(state.buyersLists.savedUnits) ? state.buyersLists.savedUnits.slice() : [],  
			  dataSet : state.buyersLists.dataSet };
}

function mapDispatchToProps(dispatch) {
  return { actions: bindActionCreators(buyersListActions, dispatch) };
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles,  { withTheme: true })(BuildingEnergy));
